import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ChatflowNameLabel from 'flow-doctor-lib/components/common/ChatflowNameLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const ExternalTriggerEnrollAnalysisReason = ({
  selectedEnrollment,
  diagnosisReason
}) => {
  const chatflowId = diagnosisReason.chatflowId;
  if (!chatflowId) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.EXTERNAL_TRIGGER_ENROLL.withoutChatflow"
    });
  }
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.EXTERNAL_TRIGGER_ENROLL.withChatflow_jsx',
      elements: {
        ChatflowNameLabel,
        b: 'b'
      },
      options: {
        portalId: selectedEnrollment.portalId,
        chatflowId
      }
    })
  });
};
export default ExternalTriggerEnrollAnalysisReason;